<div *ngIf="beneficiarioPagina!=''" class="container">

  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiario.orgao.sigla }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="2"></app-etapas-beneficio>

  <mat-card class="info-card">
    <h2>Dados Funcionais</h2>
    <div class="info-row">
      <span><strong>Órgão:</strong> {{ beneficiarioPagina.nomeOrgao }}</span>
      <span><strong>Tipo de Vínculo:</strong> {{ beneficiarioPagina.tipoVinculo }}</span>
      <span><strong>Subtipo:</strong> {{ beneficiarioPagina.subTipoVinculo }}</span>
      <span><strong>Situação Funcional:</strong> {{ beneficiarioPagina.situacaoFuncional }}</span>
      <span *ngIf="beneficiarioPagina.cargoTemporario"><strong>Cargo Temporário:</strong> {{ beneficiarioPagina.cargoTemporario }}</span>
      <span *ngIf="beneficiarioPagina.edital"><strong>Edital:</strong> {{ beneficiarioPagina.edital }}</span>
      <span><strong>Classificação:</strong> {{ beneficiarioPagina.classificacao }}</span>
      <span *ngIf="beneficiarioPagina.nomeacaoPor"><strong>Nomeação por:</strong> {{ beneficiarioPagina.nomeacaoPor }}</span>
    </div>
  </mat-card>

  <mat-card class="info-card">
    <h2>Datas</h2>
    <div class="info-row">
      <span><strong>Nomeação:</strong> {{ beneficiarioPagina.dataNomeacao | date: 'dd/MM/yyyy' }}</span>
      <span><strong>Posse:</strong> {{ beneficiarioPagina.dataDaPosse | date: 'dd/MM/yyyy' }}</span>
      <span><strong>Admissão:</strong> {{ beneficiarioPagina.dataAdmissao | date: 'dd/MM/yyyy' }}</span>
      <span *ngIf="beneficiarioPagina.dataFimDoContrato"><strong>Fim do Contrato:</strong> {{ beneficiarioPagina.dataFimDoContrato | date: 'dd/MM/yyyy' }}</span>
    </div>
  </mat-card>

  <mat-card class="info-card">
    <h2>Previdência</h2>
    <div class="info-row">
      <span><strong>Situação Previdenciária:</strong> {{ beneficiarioPagina.situacaoPrevidenciaria }}</span>
      <span *ngIf="beneficiarioPagina.regimePrevidenciario"><strong>Regime:</strong> {{ beneficiarioPagina.regimePrevidenciario }}</span>
      <span><strong>Fundo RPPS/SUPSEC:</strong> {{ beneficiarioPagina.fundoRppsSupsec }}</span>
    </div>
  </mat-card>

  <mat-card class="info-card">
    <h2>Financeiro</h2>
    <div class="info-row">
      <span><strong>Coletoria:</strong> {{ beneficiarioPagina.coletoria }}</span>
      <span><strong>Agrupamento de Folha:</strong> {{ beneficiarioPagina.agrupamentoFolha }}</span>
      <span><strong>Banco:</strong> {{ beneficiarioPagina.nomeBanco }}</span>
      <span><strong>Agência:</strong> {{ beneficiarioPagina.agencia }}</span>
      <span><strong>Conta:</strong> {{ beneficiarioPagina.conta }}</span>
    </div>
  </mat-card>

  <mat-card class="info-card">
    <h2>Jornada de Trabalho</h2>
    <div class="info-row">
      <span><strong>Carga Horária:</strong> {{ beneficiarioPagina.cagaHoraria }}h</span>
      <span><strong>Dias na Semana:</strong> {{ beneficiarioPagina.qtdDiasSemanal }}</span>
    </div>
  </mat-card>

  <mat-card class="info-card" *ngIf="beneficiarioPagina.dataDesligamento || beneficiarioPagina.dataAposentadoria">
    <h2>Desligamento / Aposentadoria</h2>
    <div class="info-row">
      <span *ngIf="beneficiarioPagina.dataDesligamento"><strong>Data Desligamento:</strong> {{ beneficiarioPagina.dataDesligamento | date: 'dd/MM/yyyy' }}</span>
      <span *ngIf="beneficiarioPagina.dataAposentadoria"><strong>Data Aposentadoria:</strong> {{ beneficiarioPagina.dataAposentadoria | date: 'dd/MM/yyyy' }}</span>
    </div>
  </mat-card>
</div>
